import { render } from "./ProposalRow.vue?vue&type=template&id=e1a99ca0"
import script from "./ProposalRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1a99ca0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1a99ca0', __exports__)) {
    api.reload('e1a99ca0', __exports__)
  }
  
  module.hot.accept("./ProposalRow.vue?vue&type=template&id=e1a99ca0", () => {
    api.rerender('e1a99ca0', render)
  })

}


export default __exports__